import { z } from 'zod';
const NullableString = z.string().nullable();
const NullableNumber = z.number().nullable();
const NullableInt = z.number().int().nullable();
/**
 * Mirrors the live `molluskio.parcels.parcels_latest` schema (see
 * `packages/shared/bq-columns.json`). Earlier hand-written drafts followed
 * `data-consumer-quickstart.md`, which uses some out-of-date column names
 * (`source_apn`, `parcel_apn`, `total_value`, `lot_size_sqft`, `state`,
 * `latitude`, `longitude`). Trust the snapshot file, not the doc.
 */
export const ParcelRow = z.object({
    parcel_id: z.string(),
    source_id: z.string(),
    source_parcel_id: NullableString,
    parcel_id_normalized: NullableString,
    address_line1: NullableString,
    city: NullableString,
    postal_code: NullableString,
    jurisdiction_state: NullableString,
    /** WKT POLYGON or MULTIPOLYGON, EPSG:4326. */
    geometry: NullableString,
    owner_name: NullableString,
    land_use_normalized: NullableString,
    zoning: NullableString,
    year_built: NullableInt,
    building_sqft: NullableInt,
    units: NullableInt,
    area_sqft: NullableNumber,
    assessed_total: NullableNumber,
    assessed_land: NullableNumber,
    assessed_improvement: NullableNumber,
});
//# sourceMappingURL=parcel.js.map